<template>
    <span></span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      applicantStatus: '',
    };
  },
  created() {
    this.$axios
      .get('/api/applicant/status')
      .then((response) => (
        this.applicantStatus = response.data
      ))
      .catch((e) => {
        // TODO: ステータスが取得できなかったときの処理
        console.log(e);
      })
      .finally(() => {
        if (this.applicantStatus != this.$props.status) {
          window.location = '/exam/redirect_by_status';
        }
        this.$emit('rewrite', this.applicantStatus);
      });
  },
};
</script>
